import { render } from "./HelpfulLink.vue?vue&type=template&id=9102b024"
import script from "./HelpfulLink.vue?vue&type=script&lang=js"
export * from "./HelpfulLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__